export const isDefined = (value) => value !== undefined;
export const updateSchema = (...schemaUpdater) => {
    return args => schemaUpdater.filter(isDefined).reduce((schema, updater) => updater({ ...args, schema }), args.schema);
};
export const updateModel = (...modelUpdate) => args => ({
    ...args.schema,
    model: modelUpdate
        .filter((it) => it !== undefined)
        .reduce((model, updater) => updater({ ...args, model }), args.schema.model),
});
export const updateEntity = (name, entityUpdate) => args => {
    if (!args.model.entities[name]) {
        throw new Error(`Entity ${name} not found`);
    }
    return {
        ...args.model,
        entities: {
            ...args.model.entities,
            [name]: entityUpdate({ ...args, entity: args.model.entities[name] }),
        },
    };
};
export const updateEveryEntity = (entityUpdate) => args => ({
    ...args.model,
    entities: Object.fromEntries(Object.entries(args.model.entities).map(([name, entity]) => [name, entityUpdate({ ...args, entity })])),
});
export const updateField = (name, fieldUpdater) => args => {
    const { [name]: field, ...otherFields } = args.entity.fields;
    if (!args.entity.fields[name]) {
        throw new Error(`Field ${args.entity.name}::${name} not found`);
    }
    const updatedField = fieldUpdater({ ...args, field: args.entity.fields[name] });
    return {
        ...args.entity,
        fields: {
            ...otherFields,
            ...(updatedField ? { [name]: updatedField } : {}),
        },
    };
};
export const updateEveryField = (fieldUpdater) => args => ({
    ...args.entity,
    fields: Object.fromEntries(Object.entries(args.entity.fields ?? {})
        .map(([name, field]) => {
        const updatedField = fieldUpdater({ ...args, field });
        if (!updatedField) {
            return undefined;
        }
        return [name, updatedField];
    })
        .filter(isDefined)),
});
export const addField = (field) => args => {
    return {
        ...args.entity,
        fields: {
            ...args.entity.fields,
            [field.name]: field,
        },
    };
};
//# sourceMappingURL=schemaUpdateUtils.js.map